import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isAuthenticated } from '../../../store/selectors/AuthSelectors';
import { credentialVaultMarketingSixBoxes } from '../../data/credentialVaultMarketingBoxes';
import './FeaturesSection.css';

const FeaturesSection = () => {
  const loggedIn = useSelector(isAuthenticated);

  const taskFeatures = [
    {
      title: 'Manage Projects',
      description: 'Manage small, medium and large projects with multiple team members'
    },
    {
      title: 'Smart Tasks',
      description: 'Create personal or shared tasks and manage with reminders and daily updates.'
    },
    {
      title: 'Team Collaboration',
      description: 'Work together seamlessly with real-time updates, shared projects, and team communication.'
    },
    {
      title: 'Progress Tracking',
      description: 'Track combined status of Projects and Tasks. Generate Transaction statements.'
    },
    {
      title: 'Smart Reminders',
      description: 'Never miss a deadline with intelligent notifications and customizable reminder settings.'
    },
    {
      title: 'Secure & Private',
      description: 'Your data is protected with enterprise-grade security and privacy controls.'
    }
  ];

  const documentFeatures = [
    {
      title: 'Cloud Storage',
      description: 'Store your documents and access them from anywhere – secure and safe.'
    },
    {
      title: 'Collaborate',
      description: 'Share documents with your departments, branch or select individuals. Update them in one place.'
    },
    {
      title: 'Version Tracking',
      description: 'Automated version tracking of the documents with access to previous versions and update logs.'
    },
    {
      title: 'Reminders',
      description: 'As per document expiry, receive reminders for renewal. Link this to Tasks for informing respective team members.'
    },
    {
      title: 'Easy Sharing',
      description: 'Share documents with your colleagues or external members with one click process.'
    },
    {
      title: 'Unlimited Storage',
      description: 'Get unlimited storage space for your organization with unlimited users.'
    }
  ];

  return (
    <section className="features-section">
      <div className="container">
        {/* flowdo Tasks Section */}
        <div className="section-block">
          <div className="section-header">
            <h2>flowdo Tasks</h2>
          </div>
          <div className="features-grid">
            {taskFeatures.map((feature, index) => (
              <div key={index} className="feature-card">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
          <div className="section-cta">
            <Link to="/register?module=task" className="subscribe-btn">
              Subscribe to Tasks
            </Link>
          </div>
        </div>

        {/* flowdo Documents Section */}
        <div className="section-block">
          <div className="section-header">
            <h2>flowdo Documents</h2>
            <p>Manage all your documents in one place, organized and secure.</p>
          </div>
          <div className="features-grid">
            {documentFeatures.map((feature, index) => (
              <div key={index} className="feature-card">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
          <div className="section-cta">
            <Link to="/register?module=document" className="subscribe-btn">
              Subscribe to Documents
            </Link>
          </div>
        </div>

        {/* flowdo Credentials Vault */}
        <div className="section-block">
          <div className="section-header">
            <h2>flowdo Credentials Vault</h2>
            <p>
              Secure storage of all your credentials in one place with selected share feature.
            </p>
          </div>
          <div className="features-grid">
            {credentialVaultMarketingSixBoxes.map((feature, index) => (
              <div key={index} className="feature-card">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
          <div className="section-cta">
            <Link
              to={
                loggedIn
                  ? '/credential-vault/credentialVaultList'
                  : '/register?module=credentialvault'
              }
              className="subscribe-btn"
            >
              Access Credentials Vault for Free
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
